import React from "react";
import { formatDate, formatAddress } from "../utils/patientUtils";

interface GeneralTabProps {
  patientData: any;
  theme?: "light" | "dark";
}

const GeneralTab: React.FC<GeneralTabProps> = ({ patientData, theme = "light" }) => {
  const InfoCard: React.FC<{ label: string; value: string | number }> = ({ label, value }) => (
    <div className={`rounded-lg p-3 ${
      theme === "dark" ? "bg-slate-700/50" : "bg-slate-50"
    }`}>
      <p className={`text-xs uppercase tracking-wide mb-1 ${
        theme === "dark" ? "text-slate-400" : "text-slate-500"
      }`}>{label}</p>
      <p className={`text-sm font-medium ${
        theme === "dark" ? "text-slate-200" : "text-slate-800"
      }`}>{value || "N/A"}</p>
    </div>
  );

  return (
    <div className="space-y-6">
      <div>
        <h4 className={`text-sm font-semibold mb-3 ${
          theme === "dark" ? "text-slate-300" : "text-slate-700"
        }`}>Personal Information</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3">
          <InfoCard label="Registered Date" value={formatDate(patientData?.registerdDate)} />
          <InfoCard label="Reg Number" value={patientData?.regNo} />
          <InfoCard label="Gender" value={patientData?.gender} />
          <InfoCard label="Date of Birth" value={formatDate(patientData?.dob)} />
          <InfoCard label="NIC" value={patientData?.nic} />
          <InfoCard label="Marital Status" value={patientData?.maritalStatus} />
          <InfoCard label="Religion" value={patientData?.religion} />
          <InfoCard label="Occupation" value={patientData?.occupation} />
          <InfoCard label="Blood Group" value={patientData?.bloodGroup} />
          <InfoCard label="Introduction" value={patientData?.nameOfIntroduce} />
        </div>
      </div>

      <div>
        <h4 className={`text-sm font-semibold mb-3 ${
          theme === "dark" ? "text-slate-300" : "text-slate-700"
        }`}>Contact Information</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3">
          <InfoCard label="Mobile No" value={patientData?.mobileNo} />
          <InfoCard label="WhatsApp" value={patientData?.whatsapp} />
          <InfoCard label="Secondary No" value={patientData?.smobileNo} />
          <InfoCard label="Email" value={patientData?.email} />
          <div className="col-span-1 sm:col-span-2">
            <div className={`rounded-lg p-3 ${
              theme === "dark" ? "bg-slate-700/50" : "bg-slate-50"
            }`}>
              <p className={`text-xs uppercase tracking-wide mb-1 ${
                theme === "dark" ? "text-slate-400" : "text-slate-500"
              }`}>Address</p>
              <p className={`text-xs sm:text-sm font-medium break-words ${
                theme === "dark" ? "text-slate-200" : "text-slate-800"
              }`}>{formatAddress(patientData?.address)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;

